import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.tsx';
import ErrorBoundary from './components/shared/ErrorBoundary.tsx';
import ProtectedRoute from './components/auth/ProtectedRoute.tsx';
import Login from './pages/Login.tsx';
import Dashboard from './pages/Dashboard.tsx';
import Properties from './pages/Properties.tsx';
import Tenants from './pages/Tenants.tsx';
import Payments from './pages/Payments.tsx';
import Bills from './pages/Bills.tsx';
import Layout from './components/shared/Layout.tsx';
import TenantDetails from './pages/TenantDetails.tsx';
import TenantSettlementsPage from './pages/TenantSettlementsPage.tsx';
import BillDetailsPage from './pages/BillDetailsPage.tsx';
import PaymentDetailsPage from './pages/PaymentDetailsPage.tsx';
import Guide from './pages/Guide.tsx';
import './App.css';
import './styles/shared/StatusBadges.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/tenants" element={<Tenants />} />
              <Route path="/tenants/:id" element={<TenantDetails />} />
              <Route path="/settlements/:id" element={<TenantSettlementsPage />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/bills" element={<Bills />} />
              <Route path="/bills/:id" element={<BillDetailsPage />} />
              <Route path="/payments/:id" element={<PaymentDetailsPage />} />
              <Route path="/settlements" element={<Payments />} />
              <Route path="/guide" element={<Guide />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
